export default __webpack_public_path__ + "static/media/season_summer.63e98558.avif";